import type {
  CollectionActions,
  CollectionStateSlice,
} from '@freelancer/datastore/core';
import {
  mergeDocuments,
  mergeWebsocketDocuments,
  transformIntoDocuments,
} from '@freelancer/datastore/core';
import { transformContentCustomization } from './content-customization.transformers';
import type { ContentCustomizationCollection } from './content-customization.types';

export function contentCustomizationReducer(
  state: CollectionStateSlice<ContentCustomizationCollection> = {},
  action: CollectionActions<ContentCustomizationCollection>,
): CollectionStateSlice<ContentCustomizationCollection> {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'contentCustomization') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<ContentCustomizationCollection>(
          state,
          transformIntoDocuments(
            result.content_customizations,
            transformContentCustomization,
          ),
          order,
          ref,
        );
      }
      return state;
    }
    case 'API_UPDATE_SUCCESS': {
      if (action.payload.type === 'contentCustomization') {
        const { ref, result } = action.payload;
        return mergeWebsocketDocuments<ContentCustomizationCollection>(
          state,
          transformIntoDocuments(
            [result.content_customization],
            transformContentCustomization,
          ),
          ref,
        );
      }
      return state;
    }

    default:
      return state;
  }
}
